'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function tariffChangesServiceFactory(_ref, _ref2) {
    var _dec, _dec2, _dec3, _dec4, _desc, _value, _class;

    var superAgent = _ref.superAgent,
        urlBuilder = _ref.urlBuilder;
    var Query = _ref2.Query,
        Command = _ref2.Command,
        EvictCollectionCache = _ref2.EvictCollectionCache;
    var Service = (_dec = Query({
        request: 'AppliedTariffRequest',
        response: 'TariffResponse'
    }), _dec2 = Command({
        request: 'CreateTariffSwitchRequestByAdmin',
        response: 'TariffResponse'
    }), _dec3 = EvictCollectionCache(['TariffChanges']), _dec4 = Command({
        request: 'CreateTariffSwitchRequest',
        response: 'TariffResponse'
    }), (_class = function () {
        function Service() {
            _classCallCheck(this, Service);
        }

        _createClass(Service, [{
            key: 'getTariffAtDate',
            value: function getTariffAtDate(rawRequest) {
                return superAgent.get(urlBuilder('api/me/tariff?market={market}&date={date}', {
                    market: rawRequest.market.name,
                    date: (0, _moment2.default)(rawRequest.date).format('YYYY-MM-DD')
                })).promise();
            }
        }, {
            key: 'changeTariffByAdmin',
            value: function changeTariffByAdmin(request) {
                return superAgent.post(urlBuilder('api/users/{lunaUserId}/tariffs/changes', {
                    lunaUserId: request.user
                })).send({
                    tariffId: request.tariff.id,
                    since: request.since && (0, _moment2.default)(request.since).format('YYYY-MM-DD')
                }).promise();
            }
        }, {
            key: 'changeTariff',
            value: function changeTariff(request) {
                return superAgent.post(urlBuilder('api/me/tariffs/changes')).send({
                    tariffId: request.tariff.id
                }).promise();
            }
        }]);

        return Service;
    }(), (_applyDecoratedDescriptor(_class.prototype, 'getTariffAtDate', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, 'getTariffAtDate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeTariffByAdmin', [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class.prototype, 'changeTariffByAdmin'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'changeTariff', [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, 'changeTariff'), _class.prototype)), _class));


    return new Service();
}

exports.default = tariffChangesServiceFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/services/tariffChangesServiceFactory.js
// module id = 1464
// module chunks = 118